import { render } from "./BaseGridWrap.vue?vue&type=template&id=567567b2"
const script = {}

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\bodensee\\wp-content\\themes\\io.shop-standalone-bodenseeenergie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__